import { observable, action } from 'mobx'
import { getMerchantInfo } from '@util'

class Store {
  @observable
  msg = {
    desc: '',
    account: '',
    butShow: false
  }

  @action
  getData = () => {
    let { is_bond, bond_fee, bond_invalid_days } = getMerchantInfo()

    if (is_bond == 1) {
      Object.assign(this.msg, {
        desc: '已加入消费者保障计划！',
        butShow: false,
        account: bond_fee
      })
    } else {
      if (bond_fee > 0) {
        if (bond_invalid_days > 7) {
          Object.assign(this.msg, {
            butShow: true,
            desc: '放心购·保证金余额不足，已被限制保证金商家权限！',
            account: bond_fee
          })
        } else {
          Object.assign(this.msg, {
            butShow: true,
            desc:
              '已加入消费者保障计划，放心购·保证金余额不足，为保障您的权益，请及时补缴保证金！',
            account: bond_fee
          })
        }
      } else {
        Object.assign(this.msg, {
          butShow: true,
          desc:
            '您还未加入消费者保障计划！加入消费者保障计划并缴纳放心购·保证金，即可享受更多商家特权。',
          account: '0.00',
          is_bond: '0'
        })
      }
    }
  }
}

export default new Store()
